// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"fa8f21cd","386":"64375697","574":"6c431455"}[chunkId] + ".chunk.js";
};